@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.business.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.business.resources/"

@delegate:ResourceContentHash(306_244_586)
internal val Res.string.claim_intro: StringResource by lazy {
      StringResource("string:claim_intro", "claim_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8252, 295),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6748, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6012, 155),
      ))
    }

@delegate:ResourceContentHash(-793_915_195)
internal val Res.string.claim_message_label: StringResource by lazy {
      StringResource("string:claim_message_label", "claim_message_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8548, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6952, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6168, 83),
      ))
    }

@delegate:ResourceContentHash(687_764_604)
internal val Res.string.claim_message_placeholder: StringResource by lazy {
      StringResource("string:claim_message_placeholder", "claim_message_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8680, 225),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7072, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6252, 145),
      ))
    }

@delegate:ResourceContentHash(860_217_237)
internal val Res.string.claim_name_label: StringResource by lazy {
      StringResource("string:claim_name_label", "claim_name_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8906, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7270, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6398, 36),
      ))
    }

@delegate:ResourceContentHash(-318_190_688)
internal val Res.string.claim_name_placeholder: StringResource by lazy {
      StringResource("string:claim_name_placeholder", "claim_name_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8951, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7307, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6435, 42),
      ))
    }

@delegate:ResourceContentHash(365_907_246)
internal val Res.string.claim_phone_label: StringResource by lazy {
      StringResource("string:claim_phone_label", "claim_phone_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9002, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7354, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6478, 57),
      ))
    }

@delegate:ResourceContentHash(-112_298_930)
internal val Res.string.claim_phone_placeholder: StringResource by lazy {
      StringResource("string:claim_phone_placeholder", "claim_phone_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9076, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7428, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6536, 51),
      ))
    }

@delegate:ResourceContentHash(1_966_219_161)
internal val Res.string.claim_proof_attach: StringResource by lazy {
      StringResource("string:claim_proof_attach", "claim_proof_attach", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9213, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7541, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6645, 54),
      ))
    }

@delegate:ResourceContentHash(866_911_886)
internal val Res.string.claim_proof_attached: StringResource by lazy {
      StringResource("string:claim_proof_attached", "claim_proof_attached", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9140, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7480, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6588, 56),
      ))
    }

@delegate:ResourceContentHash(177_181_949)
internal val Res.string.claim_proof_hint: StringResource by lazy {
      StringResource("string:claim_proof_hint", "claim_proof_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9280, 260),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7604, 216),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6700, 192),
      ))
    }

@delegate:ResourceContentHash(90_197_587)
internal val Res.string.claim_proof_label: StringResource by lazy {
      StringResource("string:claim_proof_label", "claim_proof_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9541, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7821, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6893, 49),
      ))
    }

@delegate:ResourceContentHash(-1_352_544_872)
internal val Res.string.claim_role_employee: StringResource by lazy {
      StringResource("string:claim_role_employee", "claim_role_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9603, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7875, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6943, 39),
      ))
    }

@delegate:ResourceContentHash(-1_525_432_257)
internal val Res.string.claim_role_label: StringResource by lazy {
      StringResource("string:claim_role_label", "claim_role_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9647, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7915, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6983, 36),
      ))
    }

@delegate:ResourceContentHash(-1_985_728_851)
internal val Res.string.claim_role_manager: StringResource by lazy {
      StringResource("string:claim_role_manager", "claim_role_manager", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9692, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7956, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7020, 38),
      ))
    }

@delegate:ResourceContentHash(-1_521_513_839)
internal val Res.string.claim_role_other: StringResource by lazy {
      StringResource("string:claim_role_other", "claim_role_other", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9731, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7999, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7059, 32),
      ))
    }

@delegate:ResourceContentHash(1_763_343_469)
internal val Res.string.claim_role_owner: StringResource by lazy {
      StringResource("string:claim_role_owner", "claim_role_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9768, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8032, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7092, 32),
      ))
    }

@delegate:ResourceContentHash(-24_984_364)
internal val Res.string.claim_screen_title: StringResource by lazy {
      StringResource("string:claim_screen_title", "claim_screen_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9805, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8077, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7125, 54),
      ))
    }

@delegate:ResourceContentHash(-1_609_539_093)
internal val Res.string.claim_submit: StringResource by lazy {
      StringResource("string:claim_submit", "claim_submit", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10016, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8248, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7268, 36),
      ))
    }

@delegate:ResourceContentHash(-1_451_347_224)
internal val Res.string.claim_submit_failed: StringResource by lazy {
      StringResource("string:claim_submit_failed", "claim_submit_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9880, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8140, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7180, 87),
      ))
    }

@delegate:ResourceContentHash(-1_144_649_372)
internal val Res.string.claim_success_desc: StringResource by lazy {
      StringResource("string:claim_success_desc", "claim_success_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10081, 190),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8297, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7305, 102),
      ))
    }

@delegate:ResourceContentHash(-1_644_632_772)
internal val Res.string.claim_success_done: StringResource by lazy {
      StringResource("string:claim_success_done", "claim_success_done", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10272, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8440, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7408, 34),
      ))
    }

@delegate:ResourceContentHash(1_430_710_658)
internal val Res.string.claim_success_title: StringResource by lazy {
      StringResource("string:claim_success_title", "claim_success_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10319, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8479, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7443, 47),
      ))
    }

@delegate:ResourceContentHash(526_931_105)
internal val Res.string.map_attribution: StringResource by lazy {
      StringResource("string:map_attribution", "map_attribution", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10383, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8527, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7491, 47),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.map_back_a11y: StringResource by lazy {
      StringResource("string:map_back_a11y", "map_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10431, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8575, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7539, 29),
      ))
    }

@delegate:ResourceContentHash(1_780_384_500)
internal val Res.string.map_cluster_a11y: StringResource by lazy {
      StringResource("string:map_cluster_a11y", "map_cluster_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10469, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8605, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7569, 56),
      ))
    }

@delegate:ResourceContentHash(-1_826_891_042)
internal val Res.string.map_pin_a11y: StringResource by lazy {
      StringResource("string:map_pin_a11y", "map_pin_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10546, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8666, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7626, 44),
      ))
    }

@delegate:ResourceContentHash(-400_174_121)
internal val Res.string.map_radius_km: StringResource by lazy {
      StringResource("string:map_radius_km", "map_radius_km", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10607, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8727, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7671, 33),
      ))
    }

@delegate:ResourceContentHash(-1_477_236_955)
internal val Res.string.map_recenter_a11y: StringResource by lazy {
      StringResource("string:map_recenter_a11y", "map_recenter_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10657, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8761, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7705, 53),
      ))
    }

@delegate:ResourceContentHash(1_449_047_376)
internal val Res.string.map_same_spot_title: StringResource by lazy {
      StringResource("string:map_same_spot_title", "map_same_spot_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10723, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8819, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7759, 67),
      ))
    }

@delegate:ResourceContentHash(1_496_420_641)
internal val Res.string.photo_viewer_close_a11y: StringResource by lazy {
      StringResource("string:photo_viewer_close_a11y", "photo_viewer_close_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10811, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8887, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7827, 39),
      ))
    }

@delegate:ResourceContentHash(-153_478_507)
internal val Res.string.photo_viewer_counter: StringResource by lazy {
      StringResource("string:photo_viewer_counter", "photo_viewer_counter", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10855, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8927, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7867, 44),
      ))
    }

@delegate:ResourceContentHash(1_400_206_660)
internal val Res.string.report_done: StringResource by lazy {
      StringResource("string:report_done", "report_done", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10900, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8972, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7912, 27),
      ))
    }

@delegate:ResourceContentHash(6_617_118)
internal val Res.string.report_failed: StringResource by lazy {
      StringResource("string:report_failed", "report_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10936, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9004, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7940, 69),
      ))
    }

@delegate:ResourceContentHash(-1_252_538_208)
internal val Res.string.report_reason_closed: StringResource by lazy {
      StringResource("string:report_reason_closed", "report_reason_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11054, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9090, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8010, 52),
      ))
    }

@delegate:ResourceContentHash(-1_401_425_060)
internal val Res.string.report_reason_incorrect: StringResource by lazy {
      StringResource("string:report_reason_incorrect", "report_reason_incorrect", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11135, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9151, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8063, 59),
      ))
    }

@delegate:ResourceContentHash(-283_302_589)
internal val Res.string.report_reason_offensive: StringResource by lazy {
      StringResource("string:report_reason_offensive", "report_reason_offensive", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11203, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9215, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8123, 55),
      ))
    }

@delegate:ResourceContentHash(-1_402_614_565)
internal val Res.string.report_reason_scam: StringResource by lazy {
      StringResource("string:report_reason_scam", "report_reason_scam", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11283, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9271, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8179, 46),
      ))
    }

@delegate:ResourceContentHash(-764_375_442)
internal val Res.string.report_sent: StringResource by lazy {
      StringResource("string:report_sent", "report_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11338, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9322, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8226, 79),
      ))
    }

@delegate:ResourceContentHash(1_997_569_741)
internal val Res.string.report_sheet_title: StringResource by lazy {
      StringResource("string:report_sheet_title", "report_sheet_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11458, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9410, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8306, 54),
      ))
    }

@delegate:ResourceContentHash(-1_694_482_354)
internal val Res.string.report_submit: StringResource by lazy {
      StringResource("string:report_submit", "report_submit", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11525, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9473, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8361, 37),
      ))
    }

@delegate:ResourceContentHash(319_791_594)
internal val Res.string.review_add_photo_a11y: StringResource by lazy {
      StringResource("string:review_add_photo_a11y", "review_add_photo_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11575, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9527, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8399, 41),
      ))
    }

@delegate:ResourceContentHash(1_951_975_245)
internal val Res.string.review_add_photos: StringResource by lazy {
      StringResource("string:review_add_photos", "review_add_photos", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11633, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9581, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8441, 41),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.review_back_a11y: StringResource by lazy {
      StringResource("string:review_back_a11y", "review_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11687, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9631, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8483, 32),
      ))
    }

@delegate:ResourceContentHash(1_336_464_438)
internal val Res.string.review_business_location: StringResource by lazy {
      StringResource("string:review_business_location", "review_business_location", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11728, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9664, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8516, 48),
      ))
    }

@delegate:ResourceContentHash(808_365_522)
internal val Res.string.review_disclaimer: StringResource by lazy {
      StringResource("string:review_disclaimer", "review_disclaimer", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11777, 133),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9713, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8565, 97),
      ))
    }

@delegate:ResourceContentHash(2_134_298_416)
internal val Res.string.review_experience_q: StringResource by lazy {
      StringResource("string:review_experience_q", "review_experience_q", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11911, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9815, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8663, 59),
      ))
    }

@delegate:ResourceContentHash(511_401_058)
internal val Res.string.review_report_action: StringResource by lazy {
      StringResource("string:review_report_action", "review_report_action", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11991, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9899, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8723, 48),
      ))
    }

@delegate:ResourceContentHash(-1_428_649_433)
internal val Res.string.review_report_reason_conflict: StringResource by lazy {
      StringResource("string:review_report_reason_conflict", "review_report_reason_conflict", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12044, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9952, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8772, 65),
      ))
    }

@delegate:ResourceContentHash(1_565_529_337)
internal val Res.string.review_report_reason_fake: StringResource by lazy {
      StringResource("string:review_report_reason_fake", "review_report_reason_fake", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12110, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10022, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8838, 57),
      ))
    }

@delegate:ResourceContentHash(-283_302_589)
internal val Res.string.review_report_reason_offensive: StringResource by lazy {
      StringResource("string:review_report_reason_offensive", "review_report_reason_offensive", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12184, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10080, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8896, 62),
      ))
    }

@delegate:ResourceContentHash(1_511_516_124)
internal val Res.string.review_report_reason_spam: StringResource by lazy {
      StringResource("string:review_report_reason_spam", "review_report_reason_spam", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12271, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10143, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8959, 61),
      ))
    }

@delegate:ResourceContentHash(623_902_094)
internal val Res.string.review_report_sent: StringResource by lazy {
      StringResource("string:review_report_sent", "review_report_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12353, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10209, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9021, 86),
      ))
    }

@delegate:ResourceContentHash(721_061_753)
internal val Res.string.review_report_title: StringResource by lazy {
      StringResource("string:review_report_title", "review_report_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12488, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10296, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9108, 51),
      ))
    }

@delegate:ResourceContentHash(-968_308_941)
internal val Res.string.review_star_a11y: StringResource by lazy {
      StringResource("string:review_star_a11y", "review_star_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12548, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10348, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9160, 48),
      ))
    }

@delegate:ResourceContentHash(-1_789_913_851)
internal val Res.string.review_stood_out: StringResource by lazy {
      StringResource("string:review_stood_out", "review_stood_out", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12609, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10397, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9209, 44),
      ))
    }

@delegate:ResourceContentHash(1_311_762_479)
internal val Res.string.review_submit: StringResource by lazy {
      StringResource("string:review_submit", "review_submit", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12867, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10591, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9371, 41),
      ))
    }

@delegate:ResourceContentHash(2_002_889_186)
internal val Res.string.review_submit_failed: StringResource by lazy {
      StringResource("string:review_submit_failed", "review_submit_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12682, 184),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10462, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9254, 116),
      ))
    }

@delegate:ResourceContentHash(-56_461_036)
internal val Res.string.review_tag_clean_location: StringResource by lazy {
      StringResource("string:review_tag_clean_location", "review_tag_clean_location", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12909, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10633, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9413, 53),
      ))
    }

@delegate:ResourceContentHash(1_410_822_109)
internal val Res.string.review_tag_fast_response: StringResource by lazy {
      StringResource("string:review_tag_fast_response", "review_tag_fast_response", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12967, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10683, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9467, 52),
      ))
    }

@delegate:ResourceContentHash(2_098_821_837)
internal val Res.string.review_tag_friendly_service: StringResource by lazy {
      StringResource("string:review_tag_friendly_service", "review_tag_friendly_service", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13024, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10736, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9520, 59),
      ))
    }

@delegate:ResourceContentHash(583_188_823)
internal val Res.string.review_tag_good_price: StringResource by lazy {
      StringResource("string:review_tag_good_price", "review_tag_good_price", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13096, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10792, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9580, 45),
      ))
    }

@delegate:ResourceContentHash(-228_816_952)
internal val Res.string.review_tag_professional: StringResource by lazy {
      StringResource("string:review_tag_professional", "review_tag_professional", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13154, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10834, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9626, 47),
      ))
    }

@delegate:ResourceContentHash(-341_047_700)
internal val Res.string.review_tag_recommended: StringResource by lazy {
      StringResource("string:review_tag_recommended", "review_tag_recommended", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13206, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10886, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9674, 46),
      ))
    }

@delegate:ResourceContentHash(123_167_555)
internal val Res.string.review_tap_to_rate: StringResource by lazy {
      StringResource("string:review_tap_to_rate", "review_tap_to_rate", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13277, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10933, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9721, 42),
      ))
    }

@delegate:ResourceContentHash(-1_392_982_132)
internal val Res.string.review_thoughts_label: StringResource by lazy {
      StringResource("string:review_thoughts_label", "review_thoughts_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13368, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10984, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9764, 57),
      ))
    }

@delegate:ResourceContentHash(208_542_542)
internal val Res.string.review_thoughts_placeholder: StringResource by lazy {
      StringResource("string:review_thoughts_placeholder", "review_thoughts_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13442, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11046, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9822, 119),
      ))
    }

@delegate:ResourceContentHash(-359_391_774)
internal val Res.string.review_title: StringResource by lazy {
      StringResource("string:review_title", "review_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13598, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11182, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9942, 40),
      ))
    }

@delegate:ResourceContentHash(1_544_827_994)
internal val Res.string.review_upload: StringResource by lazy {
      StringResource("string:review_upload", "review_upload", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13643, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11227, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9983, 29),
      ))
    }

@delegate:ResourceContentHash(1_833_786_877)
internal val Res.string.search_apply: StringResource by lazy {
      StringResource("string:search_apply", "search_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13689, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11265, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10013, 36),
      ))
    }

@delegate:ResourceContentHash(1_704_633_050)
internal val Res.string.search_ask_community: StringResource by lazy {
      StringResource("string:search_ask_community", "search_ask_community", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13738, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11318, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10050, 72),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.search_back_a11y: StringResource by lazy {
      StringResource("string:search_back_a11y", "search_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13835, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11391, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10123, 32),
      ))
    }

@delegate:ResourceContentHash(121_748_937)
internal val Res.string.search_browse_categories: StringResource by lazy {
      StringResource("string:search_browse_categories", "search_browse_categories", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13876, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11424, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10156, 56),
      ))
    }

@delegate:ResourceContentHash(759_391_423)
internal val Res.string.search_clear_a11y: StringResource by lazy {
      StringResource("string:search_clear_a11y", "search_clear_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13957, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11493, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10213, 41),
      ))
    }

@delegate:ResourceContentHash(1_809_362_312)
internal val Res.string.search_empty_initial: StringResource by lazy {
      StringResource("string:search_empty_initial", "search_empty_initial", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14027, 160),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11547, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10255, 104),
      ))
    }

@delegate:ResourceContentHash(-66_351_943)
internal val Res.string.search_empty_no_results: StringResource by lazy {
      StringResource("string:search_empty_no_results", "search_empty_no_results", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14188, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11660, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10360, 75),
      ))
    }

@delegate:ResourceContentHash(-2_076_811_050)
internal val Res.string.search_filter_amenities: StringResource by lazy {
      StringResource("string:search_filter_amenities", "search_filter_amenities", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14328, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11760, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10436, 43),
      ))
    }

@delegate:ResourceContentHash(1_783_283_376)
internal val Res.string.search_filter_sponsored: StringResource by lazy {
      StringResource("string:search_filter_sponsored", "search_filter_sponsored", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14380, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11808, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10480, 51),
      ))
    }

@delegate:ResourceContentHash(-678_316_103)
internal val Res.string.search_filter_verified: StringResource by lazy {
      StringResource("string:search_filter_verified", "search_filter_verified", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14448, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11872, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10532, 50),
      ))
    }

@delegate:ResourceContentHash(-406_980_231)
internal val Res.string.search_filters_a11y: StringResource by lazy {
      StringResource("string:search_filters_a11y", "search_filters_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14511, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11931, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10583, 51),
      ))
    }

@delegate:ResourceContentHash(283_545_250)
internal val Res.string.search_placeholder: StringResource by lazy {
      StringResource("string:search_placeholder", "search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14591, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11979, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10635, 74),
      ))
    }

@delegate:ResourceContentHash(1_107_889_128)
internal val Res.string.search_rating_3: StringResource by lazy {
      StringResource("string:search_rating_3", "search_rating_3", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14694, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12062, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10710, 31),
      ))
    }

@delegate:ResourceContentHash(1_256_539_780)
internal val Res.string.search_rating_4: StringResource by lazy {
      StringResource("string:search_rating_4", "search_rating_4", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14730, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12094, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10742, 31),
      ))
    }

@delegate:ResourceContentHash(-1_257_146_232)
internal val Res.string.search_rating_any: StringResource by lazy {
      StringResource("string:search_rating_any", "search_rating_any", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14766, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12126, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10774, 29),
      ))
    }

@delegate:ResourceContentHash(1_910_439_097)
internal val Res.string.search_rating_label: StringResource by lazy {
      StringResource("string:search_rating_label", "search_rating_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14800, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12160, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10804, 47),
      ))
    }

@delegate:ResourceContentHash(129_885_850)
internal val Res.string.search_recent_clear: StringResource by lazy {
      StringResource("string:search_recent_clear", "search_recent_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14860, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12208, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10852, 35),
      ))
    }

@delegate:ResourceContentHash(-29_622_882)
internal val Res.string.search_recent_title: StringResource by lazy {
      StringResource("string:search_recent_title", "search_recent_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14908, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12248, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10888, 47),
      ))
    }

@delegate:ResourceContentHash(1_338_440_718)
internal val Res.string.search_reset: StringResource by lazy {
      StringResource("string:search_reset", "search_reset", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14972, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12304, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10936, 28),
      ))
    }

@delegate:ResourceContentHash(927_793_579)
internal val Res.string.search_result_count: StringResource by lazy {
      StringResource("string:search_result_count", "search_result_count", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15017, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12345, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10965, 43),
      ))
    }

@delegate:ResourceContentHash(-151_771_547)
internal val Res.string.search_sheet_title: StringResource by lazy {
      StringResource("string:search_sheet_title", "search_sheet_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15065, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12393, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11009, 46),
      ))
    }

@delegate:ResourceContentHash(1_037_700_410)
internal val Res.string.search_sort_label: StringResource by lazy {
      StringResource("string:search_sort_label", "search_sort_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15136, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12444, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11056, 37),
      ))
    }

@delegate:ResourceContentHash(-1_119_403_221)
internal val Res.string.search_sort_most_reviewed: StringResource by lazy {
      StringResource("string:search_sort_most_reviewed", "search_sort_most_reviewed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15206, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12482, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11094, 53),
      ))
    }

@delegate:ResourceContentHash(1_974_939_884)
internal val Res.string.search_sort_name: StringResource by lazy {
      StringResource("string:search_sort_name", "search_sort_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15264, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12536, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11148, 40),
      ))
    }

@delegate:ResourceContentHash(2_017_568_476)
internal val Res.string.search_sort_nearest: StringResource by lazy {
      StringResource("string:search_sort_nearest", "search_sort_nearest", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15321, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12577, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11189, 39),
      ))
    }

@delegate:ResourceContentHash(-463_568_363)
internal val Res.string.search_sort_recommended: StringResource by lazy {
      StringResource("string:search_sort_recommended", "search_sort_recommended", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15377, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12629, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11229, 47),
      ))
    }

@delegate:ResourceContentHash(-1_500_410_177)
internal val Res.string.search_sort_top_rated: StringResource by lazy {
      StringResource("string:search_sort_top_rated", "search_sort_top_rated", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15433, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12677, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11277, 41),
      ))
    }

@delegate:ResourceContentHash(-670_390_915)
internal val Res.string.search_title: StringResource by lazy {
      StringResource("string:search_title", "search_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15503, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12723, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11319, 28),
      ))
    }

@delegate:ResourceContentHash(1_829_074_531)
internal val Res.string.time_am: StringResource by lazy {
      StringResource("string:time_am", "time_am", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15544, 23),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12760, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11348, 19),
      ))
    }

@delegate:ResourceContentHash(2_111_656_951)
internal val Res.string.time_pm: StringResource by lazy {
      StringResource("string:time_pm", "time_pm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15568, 23),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12780, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11368, 19),
      ))
    }

@delegate:ResourceContentHash(412_894_748)
internal val Res.string.weekday_fri: StringResource by lazy {
      StringResource("string:weekday_fri", "weekday_fri", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15592, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12800, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11388, 23),
      ))
    }

@delegate:ResourceContentHash(-1_624_264_288)
internal val Res.string.weekday_mon: StringResource by lazy {
      StringResource("string:weekday_mon", "weekday_mon", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15624, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12824, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11412, 23),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("claim_intro", Res.string.claim_intro)
  map.put("claim_message_label", Res.string.claim_message_label)
  map.put("claim_message_placeholder", Res.string.claim_message_placeholder)
  map.put("claim_name_label", Res.string.claim_name_label)
  map.put("claim_name_placeholder", Res.string.claim_name_placeholder)
  map.put("claim_phone_label", Res.string.claim_phone_label)
  map.put("claim_phone_placeholder", Res.string.claim_phone_placeholder)
  map.put("claim_proof_attach", Res.string.claim_proof_attach)
  map.put("claim_proof_attached", Res.string.claim_proof_attached)
  map.put("claim_proof_hint", Res.string.claim_proof_hint)
  map.put("claim_proof_label", Res.string.claim_proof_label)
  map.put("claim_role_employee", Res.string.claim_role_employee)
  map.put("claim_role_label", Res.string.claim_role_label)
  map.put("claim_role_manager", Res.string.claim_role_manager)
  map.put("claim_role_other", Res.string.claim_role_other)
  map.put("claim_role_owner", Res.string.claim_role_owner)
  map.put("claim_screen_title", Res.string.claim_screen_title)
  map.put("claim_submit", Res.string.claim_submit)
  map.put("claim_submit_failed", Res.string.claim_submit_failed)
  map.put("claim_success_desc", Res.string.claim_success_desc)
  map.put("claim_success_done", Res.string.claim_success_done)
  map.put("claim_success_title", Res.string.claim_success_title)
  map.put("map_attribution", Res.string.map_attribution)
  map.put("map_back_a11y", Res.string.map_back_a11y)
  map.put("map_cluster_a11y", Res.string.map_cluster_a11y)
  map.put("map_pin_a11y", Res.string.map_pin_a11y)
  map.put("map_radius_km", Res.string.map_radius_km)
  map.put("map_recenter_a11y", Res.string.map_recenter_a11y)
  map.put("map_same_spot_title", Res.string.map_same_spot_title)
  map.put("photo_viewer_close_a11y", Res.string.photo_viewer_close_a11y)
  map.put("photo_viewer_counter", Res.string.photo_viewer_counter)
  map.put("report_done", Res.string.report_done)
  map.put("report_failed", Res.string.report_failed)
  map.put("report_reason_closed", Res.string.report_reason_closed)
  map.put("report_reason_incorrect", Res.string.report_reason_incorrect)
  map.put("report_reason_offensive", Res.string.report_reason_offensive)
  map.put("report_reason_scam", Res.string.report_reason_scam)
  map.put("report_sent", Res.string.report_sent)
  map.put("report_sheet_title", Res.string.report_sheet_title)
  map.put("report_submit", Res.string.report_submit)
  map.put("review_add_photo_a11y", Res.string.review_add_photo_a11y)
  map.put("review_add_photos", Res.string.review_add_photos)
  map.put("review_back_a11y", Res.string.review_back_a11y)
  map.put("review_business_location", Res.string.review_business_location)
  map.put("review_disclaimer", Res.string.review_disclaimer)
  map.put("review_experience_q", Res.string.review_experience_q)
  map.put("review_report_action", Res.string.review_report_action)
  map.put("review_report_reason_conflict", Res.string.review_report_reason_conflict)
  map.put("review_report_reason_fake", Res.string.review_report_reason_fake)
  map.put("review_report_reason_offensive", Res.string.review_report_reason_offensive)
  map.put("review_report_reason_spam", Res.string.review_report_reason_spam)
  map.put("review_report_sent", Res.string.review_report_sent)
  map.put("review_report_title", Res.string.review_report_title)
  map.put("review_star_a11y", Res.string.review_star_a11y)
  map.put("review_stood_out", Res.string.review_stood_out)
  map.put("review_submit", Res.string.review_submit)
  map.put("review_submit_failed", Res.string.review_submit_failed)
  map.put("review_tag_clean_location", Res.string.review_tag_clean_location)
  map.put("review_tag_fast_response", Res.string.review_tag_fast_response)
  map.put("review_tag_friendly_service", Res.string.review_tag_friendly_service)
  map.put("review_tag_good_price", Res.string.review_tag_good_price)
  map.put("review_tag_professional", Res.string.review_tag_professional)
  map.put("review_tag_recommended", Res.string.review_tag_recommended)
  map.put("review_tap_to_rate", Res.string.review_tap_to_rate)
  map.put("review_thoughts_label", Res.string.review_thoughts_label)
  map.put("review_thoughts_placeholder", Res.string.review_thoughts_placeholder)
  map.put("review_title", Res.string.review_title)
  map.put("review_upload", Res.string.review_upload)
  map.put("search_apply", Res.string.search_apply)
  map.put("search_ask_community", Res.string.search_ask_community)
  map.put("search_back_a11y", Res.string.search_back_a11y)
  map.put("search_browse_categories", Res.string.search_browse_categories)
  map.put("search_clear_a11y", Res.string.search_clear_a11y)
  map.put("search_empty_initial", Res.string.search_empty_initial)
  map.put("search_empty_no_results", Res.string.search_empty_no_results)
  map.put("search_filter_amenities", Res.string.search_filter_amenities)
  map.put("search_filter_sponsored", Res.string.search_filter_sponsored)
  map.put("search_filter_verified", Res.string.search_filter_verified)
  map.put("search_filters_a11y", Res.string.search_filters_a11y)
  map.put("search_placeholder", Res.string.search_placeholder)
  map.put("search_rating_3", Res.string.search_rating_3)
  map.put("search_rating_4", Res.string.search_rating_4)
  map.put("search_rating_any", Res.string.search_rating_any)
  map.put("search_rating_label", Res.string.search_rating_label)
  map.put("search_recent_clear", Res.string.search_recent_clear)
  map.put("search_recent_title", Res.string.search_recent_title)
  map.put("search_reset", Res.string.search_reset)
  map.put("search_result_count", Res.string.search_result_count)
  map.put("search_sheet_title", Res.string.search_sheet_title)
  map.put("search_sort_label", Res.string.search_sort_label)
  map.put("search_sort_most_reviewed", Res.string.search_sort_most_reviewed)
  map.put("search_sort_name", Res.string.search_sort_name)
  map.put("search_sort_nearest", Res.string.search_sort_nearest)
  map.put("search_sort_recommended", Res.string.search_sort_recommended)
  map.put("search_sort_top_rated", Res.string.search_sort_top_rated)
  map.put("search_title", Res.string.search_title)
  map.put("time_am", Res.string.time_am)
  map.put("time_pm", Res.string.time_pm)
  map.put("weekday_fri", Res.string.weekday_fri)
  map.put("weekday_mon", Res.string.weekday_mon)
}
